import { makeStyles } from '@material-ui/core';
import React from 'react';
import { useSelector } from 'react-redux';

import { colors } from 'src/themes/colors';
import { CalendarData } from 'src/pages/SessionsPage';
import { getCurrentUser } from 'src/selectors/userSelectors';

import { AvailabilityNotSet } from './AvailabilityNotSet';
import { AvailabilityWithHours } from './AvailabilityWithHours';
import { AvailabilityWithNoHours } from './AvailabilityWithNoHours';
import { AvailabilityWithRoster } from './AvailabilityWithRoster';

const useStyles = makeStyles({
  header: {
    minHeight: 400,
    width: '100%',
    backgroundColor: colors.gray9,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },
});

interface Props {
  setCalendarModalOpen: (open: boolean) => void;
  setWorkingHoursModalOpen: (open: boolean) => void;
  setPickSessionTypeModalOpen: (open: boolean) => void;
  handleSeeAvailabilityCalendar: () => void;
  missingCheckForConflicts: boolean;
  calendarData?: CalendarData;
  loading?: boolean;
}

export const AvailabilityHeader: React.FC<Props> = ({
  setCalendarModalOpen,
  setWorkingHoursModalOpen,
  setPickSessionTypeModalOpen,
  handleSeeAvailabilityCalendar,
  missingCheckForConflicts,
  calendarData,
  loading = false,
}) => {
  const classes = useStyles();
  const user = useSelector(getCurrentUser);

  const handleGetStartedClick = () =>
    (user.isTherapist ? setPickSessionTypeModalOpen : setCalendarModalOpen)(true);

  const calendarConnected = calendarData?.profiles?.length;
  const hasSetHours = (calendarData?.availableHours?.length || 0) > 0;

  const rosterMode = !!user.newClientCapacity || user.newClientCapacity === 0;

  return (
    <div className={classes.header}>
      {loading && (
        <AvailabilityWithHours
          calendarData={calendarData}
          firstName={user.firstName}
          missingCheckForConflicts={missingCheckForConflicts}
          onPreviewAvailabilityClick={handleSeeAvailabilityCalendar}
          onManageWorkingHoursClick={() => setWorkingHoursModalOpen(true)}
          onPreviewCalendarConnectionsClick={() => setCalendarModalOpen(true)}
          loading={loading}
        />
      )}
      {!loading &&
        (calendarData && rosterMode && !calendarConnected ? (
          <AvailabilityWithRoster
            firstName={user.firstName}
            clientOpenings={user.newClientCapacity}
            onManageAvailabilityClick={handleGetStartedClick}
          />
        ) : !calendarConnected && !loading ? (
          <AvailabilityNotSet onGetStartedClick={handleGetStartedClick} />
        ) : hasSetHours && calendarData ? (
          <AvailabilityWithHours
            calendarData={calendarData}
            firstName={user.firstName}
            missingCheckForConflicts={missingCheckForConflicts}
            onPreviewAvailabilityClick={handleSeeAvailabilityCalendar}
            onManageWorkingHoursClick={() => setWorkingHoursModalOpen(true)}
            onPreviewCalendarConnectionsClick={() => setCalendarModalOpen(true)}
          />
        ) : (
          <AvailabilityWithNoHours
            firstName={user.firstName}
            missingCheckForConflicts={missingCheckForConflicts}
            onManageWorkingHoursClick={() => setWorkingHoursModalOpen(true)}
            onReviewCalendarConnectionsClick={() => setCalendarModalOpen(true)}
            loading={loading}
          />
        ))}
    </div>
  );
};
